import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/useAuthStore'

const DashboardRedirect = () => {
  const navigate = useNavigate()
  const { user, profile, loading } = useAuthStore()
  const [redirectAttempted, setRedirectAttempted] = useState(false)

  useEffect(() => {
    // Add timeout to prevent infinite loading
    const timeout = setTimeout(() => {
      if (!redirectAttempted) {
        console.log('Redirect timeout - forcing redirect to client dashboard')
        navigate('/client', { replace: true })
      }
    }, 3000)

    if (!loading) {
      if (user && profile) {
        console.log('User and profile loaded, redirecting...', { role: profile.role })
        setRedirectAttempted(true)
        
        // Redirect to appropriate dashboard
        if (profile.role === 'admin') {
          navigate('/admin', { replace: true })
        } else if (profile.role === 'employee') {
          navigate('/employee', { replace: true })
        } else if (profile.role === 'client') {
          navigate('/client', { replace: true })
        } else {
          navigate('/client', { replace: true }) // Default to client
        }
      } else if (!user) {
        console.log('No user found, redirecting to login')
        navigate('/login', { replace: true })
      } else if (user && !profile) {
        console.log('User found but no profile, redirecting to client dashboard')
        navigate('/client', { replace: true })
      }
    }

    return () => clearTimeout(timeout)
  }, [user, profile, loading, navigate, redirectAttempted])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="loading-spinner mb-4"></div>
        <p className="text-gray-600">Redirecting to dashboard...</p>
        <p className="text-sm text-gray-500 mt-2">
          Loading: {loading ? 'Yes' : 'No'} | User: {user ? 'Yes' : 'No'} | Profile: {profile ? 'Yes' : 'No'}
        </p>
      </div>
    </div>
  )
}

export default DashboardRedirect
